import { Link } from "gatsby"
import React from "react"
import './Header.css'
import '../components/theme.js'

class Header extends React.Component{

  constructor(props){
    super(props)

    this.state = {
      hasScrolled:false
    }
  }

  componentDidMount(){
    window.addEventListener('scroll',this.handleScroll)
  }
  
  handleScroll = (event) =>{
    const scrollTop = window.pageYOffset

    if(scrollTop > 50){
      this.setState({hasScrolled:true})
    }else{
      this.setState({hasScrolled:false})
    }
  }
  render(){
    return(
        <div className={this.state.hasScrolled? 'Header HeaderScrolled':'Header'}>
          <div className="HeaderGroup">
            <Link to="/"><img src={require('../images/Logo.svg')}  width="72" height="28"/></Link>
            <Link to="/">Overview</Link>
            <Link to="/Bingo">Collections</Link>
            <Link to="/Team">Cooperation</Link>
            <a href="https://job.xiaohongshu.com/" target="_blank"><button>Join Us</button></a>
          </div>
        </div>
    )
  }
}

export default Header
